import { forceDismissAppBoot, isAppBootOverlayActive } from '../components/loading/dismissAppBoot';

const DEFAULT_IDLE_MS = 2 * 60 * 60 * 1000; // 2 hours
const LAST_ACTIVE_KEY = 'vb_last_active_at';
const PROMPT_EVENT = 'vb-app-update-prompt';

function isProtectedRoute() {
  const path = window.location.pathname || '';
  return path.includes('/casino/game/');
}

function readLastActive() {
  try {
    const n = Number(localStorage.getItem(LAST_ACTIVE_KEY) || 0);
    return Number.isFinite(n) && n > 0 ? n : 0;
  } catch {
    return 0;
  }
}

export function touchAppActivity() {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(LAST_ACTIVE_KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
}

function emitUpdatePrompt() {
  if (typeof window === 'undefined') return;
  if (isProtectedRoute()) return;
  window.dispatchEvent(new CustomEvent(PROMPT_EVENT, { detail: { reason: 'idle' } }));
}

/**
 * After a long absence (tab hidden / closed), show the update prompt instead of
 * auto-reloading. Clicking Update in the UI reloads the page.
 */
export function startIdlePageReload({ idleMs = DEFAULT_IDLE_MS } = {}) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return () => {};

  let hiddenAt = document.hidden ? Date.now() : 0;
  const last = readLastActive();
  if (last && Date.now() - last >= idleMs && !document.hidden) {
    queueMicrotask(() => emitUpdatePrompt());
  }
  if (!document.hidden) touchAppActivity();

  const maybePrompt = () => {
    if (document.hidden) return;
    if (isProtectedRoute()) {
      hiddenAt = Date.now();
      touchAppActivity();
      return;
    }

    const awayMs = hiddenAt ? Date.now() - hiddenAt : 0;
    const storedAway = last ? Date.now() - readLastActive() : 0;
    const idleLongEnough = (hiddenAt && awayMs >= idleMs) || storedAway >= idleMs;
    if (!idleLongEnough) {
      touchAppActivity();
      return;
    }

    hiddenAt = 0;
    emitUpdatePrompt();
    touchAppActivity();
  };

  const onVisibility = () => {
    if (document.hidden) {
      hiddenAt = Date.now();
      touchAppActivity();
      return;
    }
    if (isAppBootOverlayActive()) {
      forceDismissAppBoot();
    }
    maybePrompt();
  };

  const onPageShow = (event) => {
    if (event.persisted) {
      if (isAppBootOverlayActive()) forceDismissAppBoot();
      maybePrompt();
    }
  };

  const onFocus = () => {
    if (!document.hidden) maybePrompt();
  };

  document.addEventListener('visibilitychange', onVisibility);
  window.addEventListener('pageshow', onPageShow);
  window.addEventListener('focus', onFocus);

  return () => {
    document.removeEventListener('visibilitychange', onVisibility);
    window.removeEventListener('pageshow', onPageShow);
    window.removeEventListener('focus', onFocus);
  };
}

export { PROMPT_EVENT as APP_UPDATE_PROMPT_EVENT };
